<div class="header-c">
    {{name}} $ {{formatName(type)}}
</div>
<div *ngIf="reqst===1" class="text-center loader-container">
    <div class="spinner-grow align-middle text-primary" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>
<div class="flex-item"
    *ngIf="reqst===2">
    <div>
        <highcharts-chart id="mychart1" class="chart" [Highcharts]="Highcharts" [options]="chartOptions"></highcharts-chart>
    </div>
</div>